<div class="row">
  <div class="header-tab">
    <div class="row flex-left">
      <li
        v-for="tab in tabs"
        @click="setActiveTab(tab)"
        :class="{ 'active': (tab?.name === active || tab === active) }"
      >
        {{ $i18n.locale === 'en' ? tab?.en : tab?.km }}
      </li>
    </div>
    <!-- <div class="row flex-right">...</div> -->
  </div>
</div>
